import * as actionsTypes from '../actions/actionsTypes';

const initialState = {
  result: [],
  loadSuggestions: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionsTypes.MULTI_SEARCH_PENDING: {
      return {
        ...state,
        result: [],
        loadSuggestions: false,
      };
    }

    case actionsTypes.MULTI_SEARCH_FULFILLED: {
      return {
        ...state,
        result: action.payload.results,
        loadSuggestions: true,
      };
    }

    default:
      return state;
  }
};

export default reducer;
